module.exports = __webpack_public_path__ + "img/job-position.56462fc0.webp";